export const useRecaptcha = () => {
  const { $recaptcha } = useNuxtApp();

  const getToken = async (action = 'submit') => {
    return await $recaptcha.getToken(action);
  };

  const preloadScript = async () => {
    return await $recaptcha.preload();
  };

  return {
    getToken,
    preloadScript,
  };
};
